import AnimatedPage from "@/components/AnimatedPage";
import HeaderBox from "@/components/HeaderBox";
import HelmetMetaData from "@/components/HelmetMetaData";
import NetworkTiles from "@/components/dashboard/NetworkTiles";
import BuyDataForm from "@/components/forms/BuyDataForm";
import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { GetRequest, PostRequest } from "@/lib/http";
import { Report } from "notiflix";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import AirtimeSkeleton from "@/components/skeletons/airtime-skeleton";
import AnnouncementMessage from "@/components/dashboard/AnnouncementMessage";

const BuyData = () => {
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openDataDrawer, setOpenDataDrawer] = useState(false);

  const location = useLocation();
  const beneficiaryData = location.state;
  // const initialSetupDone = useRef(false);

  const {
    setValue,
    register,
    formState: { errors },
    handleSubmit,
    watch,
    reset,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: {
      carrier: "",
      saveBeneficiary: false,
      pin: "",
    },
  });

  async function getData() {
    const { err, data } = await GetRequest({
      url: "/api/data",
      setState: setLoading,
    });

    if (!err) {
      setPlans(data);

      if (beneficiaryData) {
        setValue("phone", beneficiaryData.value);

        const telcosKeys = Object.keys(data);
        const telcoType = telcosKeys.find((t) =>
          beneficiaryData.network.toLowerCase().includes(t.toLowerCase()),
        );
        setValue("carrier", telcoType);
      }
    } else {
      Report.failure("Error", err);
      toast.error("Error", { description: err });
    }
  }

  async function onSubmit(formData) {
    const { err } = await PostRequest({
      url: "/api/buyData/" + formData.plan,
      body: formData,
      setState: setIsSubmitting,
    });

    if (!err) {
      toast.success("Dataplan purchased successfully");
      reset();
      setOpenDataDrawer(false);
    } else {
      toast.error("Data purchase error", { description: err });
      setOpenDataDrawer(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const telcos = Object.keys(plans);
  const network = watch("carrier");
  const planLists = plans[network];

  return (
    <AnimatedPage>
      <HelmetMetaData
        title="Purchase Data Plans"
        description="Access affordable mobile data plans effortlessly. Buy data packages online to keep your devices connected and enjoy seamless browsing!"
      />

      <section className="p-3 sm:p-5">
        <div className="flex flex-col-reverse items-start justify-between md:flex-row">
          <HeaderBox
            title="Buy Data Anytime"
            subtext="Conveniently buy data from anywhere—quick, reliable, and user-friendly!"
          />
          <div>
            <h2 className="text-sm font-medium">
              <Link to="/dashboard" className="hover:underline">
                Dashboard
              </Link>
              <span className="px-2 text-xl font-thin">/</span>
              <span className="text-gray-400">Buy Data</span>
            </h2>
          </div>
        </div>

        {!loading ? (
          <>
            <NetworkTiles
              setValue={setValue}
              selected={network}
              telcos={telcos}
              valueKey={"carrier"}
              type="data"
            />

            {network === "airtel" ? (
              <div className="mx-2 mt-2">
                <AnnouncementMessage msg="AIRTEL USERS: Please ensure you have no outstanding balance before making a data purchase." />
              </div>
            ) : (
              <marquee direction="left" className="font-bold">
                All mobile network services - [Airtime Recharge] - *311# -
                [AccountBalance] - *310# - [Share Services] - *321# - [Borrowing
                Services] -[Data Plans] - *312# - *303# - [Data Balance] - *321#
              </marquee>
            )}

            <BuyDataForm
              plans={planLists}
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              onSubmit={onSubmit}
              telcos={telcos}
              watch={watch}
              loading={isSubmitting}
              setValue={setValue}
              beneficiaryData={beneficiaryData}
              setError={setError}
              clearErrors={clearErrors}
              openDataDrawer={openDataDrawer}
              setOpenDataDrawer={setOpenDataDrawer}
            />
          </>
        ) : (
          <AirtimeSkeleton />
        )}
      </section>
    </AnimatedPage>
  );
};

export default BuyData;
